import axios from "@/utils/axios.js";

/**
 * 判断该楼盘能否被推荐
 * @param {string} id 楼盘ID
 */
export async function buildingCanRecommend(id) {
  let url = `/houses/recommendFlag/${encodeURIComponent(id)}`;
  return axios.get(url);
}

/**
 *
 * @param {string} buildingId 楼盘ID
 * @param {number} status  50 拓客团队，10 全民经纪人， 40 华发员工， 30 华发业主
 */
export async function getRulesOfBuilding(buildingId, status) {
  let url = `/customReport/getRuleConfigure/${encodeURIComponent(
    buildingId
  )}/${status}`;
  return axios.get(url);
}

/**
 * 保存客户报备信息
 * @param {object} params 客户报备页中包含的信息:姓名、性别、手机号、推荐的楼盘、置业顾问、备注
 * cusName: 姓名
 * cusSex: 性别
 * cusTel: 手机号
 * housesId: 推荐的楼盘（多个用逗号分隔）
 * remarks: 置业顾问
 * reportAgentName: agentName 备注
 */
export async function saveClientInfo(params) {
  return axios.post("/customReport/saveReportMoreHouse", params);
}

/**
 * 根据规则类型获取当前最新楼盘的规则条款（多房源,房源id使用英文逗号隔开）
 * @param {string} housesUuids 推荐的楼盘（多个用逗号分隔）
 * @param {number} ruleType 30
 */
export async function getNewestRuleList(housesUuids, ruleType) {
  let url = `/customReport/getNewestRuleList/${housesUuids}/${ruleType}`;
  return axios.get(url);
}
